import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.facility.add');
import { OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-facility-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.facility.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectFacilityAddComponent implements OnInit, OnChanges {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Input() drawings: any[] = [];
    @Output() onClose = new EventEmitter<void>();
    @Output() onCreated = new EventEmitter<void>();

    public data: any = {
        name: '',
        description: ''
    };
    public drawingsList: any[] = [];
    public isCreating: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        this.initDrawingsList();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['drawings'] || changes['isOpen']) {
            this.initDrawingsList();
        }
    }

    private initDrawingsList() {
        this.drawingsList = (this.drawings || []).map(d => ({ ...d, selected: false }));
    }

    public close() {
        this.data = { name: '', description: '' };
        this.drawingsList.forEach(d => d.selected = false);
        this.onClose.emit();
    }

    public toggleDrawing(drawing: any) {
        drawing.selected = !drawing.selected;
        this.ref.detectChanges();
    }

    public isPdf(drawing: any): boolean {
        const filepath = drawing?.filepath || drawing?.file_path || '';
        return filepath.toLowerCase().endsWith('.pdf');
    }

    public getFileName(drawing: any): string {
        // DB 스키마: filename 필드 사용
        if (drawing?.filename) return drawing.filename;
        // fallback: filepath에서 추출
        const filepath = drawing?.filepath || drawing?.file_path || '';
        if (!filepath) return '제목 없음';
        const parts = filepath.split('/');
        return parts[parts.length - 1];
    }

    public async create() {
        if (!this.data.name.trim()) {
            await this.service.alert.show({
                title: '알림',
                message: '시설물명을 입력하세요.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.isCreating = true;
        await this.service.loading.show();

        const selectedDrawings = this.drawingsList.filter(d => d.selected).map(d => d.id);
        const { code, data } = await wiz.call("create_facility", {
            project_id: this.projectId,
            name: this.data.name,
            description: this.data.description,
            drawing_ids: JSON.stringify(selectedDrawings)
        });

        await this.service.loading.hide();
        this.isCreating = false;

        if (code === 200) {
            await this.service.alert.show({
                title: '성공',
                message: '시설물이 추가되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
            this.onCreated.emit();
            this.close();
        } else {
            await this.service.alert.show({
                title: '오류',
                message: data || '시설물 추가에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }

        this.ref.detectChanges();
    }
}

export default ComponentProjectFacilityAddComponent;